import React, {useState, useEffect} from 'react';
import {Col} from "react-bootstrap";
import {useHttp} from "../../hooks/use-http";
import {HomeNewsList} from "./HomeNewsList";
import {HomeEventsList} from "./HomeEventsList";
import {HomeArticleContent} from "./HomeArticleContent";
import {HomeContentContainer, HomeContentRow} from "../../utils/common-styles";
import {LoadingHomeNewsList} from '../Extra/Loading/LoadingHomeNewsList';
import {LoadingHomeEventsList} from '../Extra/Loading/LoadingHomeEventsList';

export default function HomeContent() {

    const [newsItems, setNewsItems] = useState([]);
    const [eventItems, setEventItems] = useState([]);
    const [articleItems, setArticleItems] = useState([]);

    const {error, isLoading, sendRequest: getContent} = useHttp();

    useEffect(() => {

        const transformResponse = (data) => {
            setNewsItems(data.payload.content.news ? data.payload.content.news : []);
            setEventItems(data.payload.content.events ? data.payload.content.events : []);
            setArticleItems(data.payload.content.articles ? data.payload.content.articles : []);
        };

        getContent({url: '/cms/home'}, transformResponse);
    }, [getContent]);


    return (
        <>
        <HomeContentContainer>
            <HomeContentRow>
                <Col xs={12} md={8}>
                    {error && <p>{error}</p>}
                    {isLoading && <LoadingHomeNewsList />}
                    {newsItems && <HomeNewsList posts={newsItems}/>}
                </Col>
                <Col xs={12} md={4}>
                    {error && <p>{error}</p>}
                    {isLoading && <LoadingHomeEventsList />}
                    {!isLoading && <HomeEventsList posts={eventItems} />}
                </Col>
            </HomeContentRow>
        </HomeContentContainer>
        
        <HomeArticleContent posts={articleItems} />
        </>
    )
}
